var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimesCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.001,2c-5.523,0 -10,4.477 -10,10s4.477,10 10,10c5.523,0 10,-4.477 10,-10l0,0c-0.006,-5.52 -4.48,-9.994 -9.999,-10l-0.001,0zm6.481,15.575c-1.577,1.819 -3.89,2.962 -6.471,2.962c-4.721,0 -8.549,-3.828 -8.549,-8.549s3.828,-8.549 8.549,-8.549c4.721,0 8.549,3.828 8.549,8.549c0,0.004 0,0.008 0,0.012l0,-0.001c-0.002,2.137 -0.788,4.089 -2.087,5.586l0.009,-0.011l0,0.001z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "m13.4561,11.82831l3.05399,-3.05387a0.88497,0.88497 0 0 0 -1.25194,-1.25171l-3.05387,3.05387l-3.05399,-3.05399a0.88497,0.88497 0 0 0 -1.25171,1.25171l3.05399,3.05399l-3.0541,3.05399a0.88497,0.88497 0 0 0 1.25171,1.25183l3.05399,-3.0541l3.05399,3.0541a0.88497,0.88497 0 1 0 1.25183,-1.25183l-3.05387,-3.05399z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimesCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/times-circle.c5d7ecfb.svg";
export { ForwardRef as ReactComponent };